import { useMemo } from "react";

import { QuotationLineModelDocumentModelContractStatusEnum } from "api";
import useFeatureFlag from "hooks/useFeatureFlag";
import usePermission from "hooks/usePermission";
import useSelects from "hooks/useSelects";
import { UNSIGNED_CONTRACT_FILTER_STATUS } from "services/ContractService";
import { ESIGN } from "util/featureFlags";

const contractFilterOptionCategories = [
  {
    placeholder: "Signature",
    filterKey: "signature",
  },
  {
    placeholder: "Status",
    filterKey: "statuses",
  },
  {
    placeholder: "Product",
    filterKey: "products",
  },
];

const esignStatusFilterOption = {
  signature: {
    label: "Available to sign",
    value: UNSIGNED_CONTRACT_FILTER_STATUS,
  },
};

const openStatusFilterOption = {
  statuses: QuotationLineModelDocumentModelContractStatusEnum.Open as string,
};
const closeStatusFilterOption = {
  statuses: QuotationLineModelDocumentModelContractStatusEnum.Closed as string,
};
const requestedStatusFilterOption = {
  statuses: QuotationLineModelDocumentModelContractStatusEnum.Request as string,
};
const offerStatusFilterOption = {
  statuses: QuotationLineModelDocumentModelContractStatusEnum.Offer as string,
};
const useContractFilterOptions = (contracts?: Contract[]) => {
  const hasEsignFeatureFlag = useFeatureFlag(ESIGN.SIGN);
  const hasEsignPermission = usePermission(ESIGN.SIGN);
  const hasEsignFilterOption = hasEsignPermission && hasEsignFeatureFlag;

  const availableFilterValues = useMemo(() => {
    if (!contracts) {
      return undefined;
    }
    return [
      ...contracts.map((value) => ({
        products: value.productName,
      })),
      ...(hasEsignFilterOption
        ? [
            requestedStatusFilterOption,
            offerStatusFilterOption,
            openStatusFilterOption,
            closeStatusFilterOption,
            esignStatusFilterOption,
          ]
        : [
            requestedStatusFilterOption,
            offerStatusFilterOption,
            openStatusFilterOption,
            closeStatusFilterOption,
          ]),
    ];
  }, [contracts, hasEsignFilterOption]);

  const { selectStates: filterOptions } = useSelects({
    values: availableFilterValues,
    selectMetadata: contractFilterOptionCategories,
  });

  return filterOptions;
};

export default useContractFilterOptions;
